import api from '@services/api';
import { EventsRequest, EventsResponse, EventsResponseByBadge } from '../models/providersResponse';

/**
 * <p>
 * API endpoints that cover all resource period related CRUD calls
 */
export const periodApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listEventsByPeriodAndPerson: builder.query<EventsResponse[], EventsRequest>({
      query: (request: EventsRequest) => ({
        url: encodeURI(
          `/indirect/monthly-expense/listByPeriodAndPerson?period=${request.period}&badge=${request.badge}`,
        ),
      }),
      providesTags: ['Periods'],
    }),
    listByPeriodAndPersonAndProvider: builder.query<EventsResponseByBadge[], EventsRequest>({
      query: (request: EventsRequest) => ({
        url: encodeURI(
          `/indirect/monthly-expense/listByPeriodAndPersonAndProvider?period=${request.period}&badge=${request.badge}&code=${request.code}`,
        ),
      }),
      providesTags: ['Periods'],
    }),
  }),
});

export const { useListEventsByPeriodAndPersonQuery, useListByPeriodAndPersonAndProviderQuery } = periodApi;
